import React, { Fragment } from "react";
import { useTranslation } from "react-i18next";
import { LangConstant } from "const";
import { useUnitList } from "hooks";
import { PageTitle } from "components";
import { UserStatistic, MessageStatistic, CallStatistic, GroupStatistic, GeneralSummaryCards } from "./components";

const Statistic = () => {
  const { t: getLabel } = useTranslation();
  const titleObjectContent = getLabel(LangConstant.OBJ_SIDEBAR_TITLE, { returnObjects: true });

  const { totalUnitList } = useUnitList();

  const sortedUnitList = [
    { unitId: "0", unitName: getLabel(LangConstant.TXT_FILTER_ALL) },
    { unitId: "-1", unitName: getLabel(LangConstant.TXT_FILTER_OTHER) },
  ].concat(
    [...totalUnitList].sort((a, b) => {
      return (a.unitName || "").localeCompare(b.unitName || "", "vi");
    }),
  );

  return (
    <Fragment>
      <PageTitle>{getLabel(titleObjectContent.statistic)}</PageTitle>

      <GeneralSummaryCards />

      <div className="card mb-3">
        <div className="card-body">
          <UserStatistic unitList={sortedUnitList} />
        </div>
      </div>

      <div className="card mb-3">
        <div className="card-body">
          <MessageStatistic unitList={sortedUnitList} />
        </div>
      </div>

      <div className="card mb-3">
        <div className="card-body">
          <CallStatistic unitList={sortedUnitList} />
        </div>
      </div>

      <div className="card mb-3">
        <div className="card-body">
          <GroupStatistic />
        </div>
      </div>
    </Fragment>
  );
};

export default Statistic;
